import _extends from "/home/runner/work/loan-application-form/loan-application-form/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "/home/runner/work/loan-application-form/loan-application-form/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _classCallCheck from "/home/runner/work/loan-application-form/loan-application-form/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _possibleConstructorReturn from "/home/runner/work/loan-application-form/loan-application-form/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/runner/work/loan-application-form/loan-application-form/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _assertThisInitialized from "/home/runner/work/loan-application-form/loan-application-form/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _createClass from "/home/runner/work/loan-application-form/loan-application-form/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/home/runner/work/loan-application-form/loan-application-form/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _defineProperty from "/home/runner/work/loan-application-form/loan-application-form/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import React from 'react';
import { Platform, StyleSheet, View } from 'react-native';
import { SceneView } from '@react-navigation/core';
var FAR_FAR_AWAY = 3000; // this should be big enough to move the whole view out of its container

var ResourceSavingSceneView =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(ResourceSavingSceneView, _React$PureComponent);

  _createClass(ResourceSavingSceneView, null, [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps, prevState) {
      if (nextProps.isFocused && !prevState.awake) {
        return {
          awake: true
        };
      } else {
        return null;
      }
    }
  }]);

  function ResourceSavingSceneView(props) {
    var _this;

    _classCallCheck(this, ResourceSavingSceneView);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ResourceSavingSceneView).call(this));

    _defineProperty(_assertThisInitialized(_this), "_mustAlwaysBeVisible", function () {
      return _this.props.animationEnabled || _this.props.swipeEnabled;
    });

    _this.state = {
      awake: props.lazy ? props.isFocused : true
    };
    return _this;
  }

  _createClass(ResourceSavingSceneView, [{
    key: "render",
    value: function render() {
      var awake = this.state.awake;

      var _this$props = this.props,
          isFocused = _this$props.isFocused,
          childNavigation = _this$props.childNavigation,
          removeClippedSubviews = _this$props.removeClippedSubviews,
          rest = _objectWithoutProperties(_this$props, ["isFocused", "childNavigation", "removeClippedSubviews"]);

      return React.createElement(View, {
        style: styles.container,
        collapsable: false,
        removeClippedSubviews: Platform.OS === 'android' ? removeClippedSubviews : !isFocused && removeClippedSubviews
      }, React.createElement(View, {
        style: this._mustAlwaysBeVisible() || isFocused ? styles.innerAttached : styles.innerDetached
      }, awake ? React.createElement(SceneView, _extends({}, rest, {
        navigation: childNavigation
      })) : null));
    }
  }]);

  return ResourceSavingSceneView;
}(React.PureComponent);

var styles = StyleSheet.create({
  container: {
    flex: 1,
    overflow: 'hidden'
  },
  innerAttached: {
    flex: 1
  },
  innerDetached: {
    flex: 1,
    top: FAR_FAR_AWAY
  }
});
export default ResourceSavingSceneView;